/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Fabien SERRA
 * @date        14/02/2022 16:30
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import 'jquery'
import DataLayerService from './services/data-layer.service'
import MediacopyrightService from './services/mediacopyright.service'
import IframeResizerService from "./services/iframe-resizer.service";

document.addEventListener('DOMContentLoaded', () => {
    new DataLayerService()
    new IframeResizerService()
    new MediacopyrightService()

    if ($('[data-element="player-video"]').length > 0) {
        import(
            '@scripts/components/videoPlayer' /* webpackChunkName: "scripts/videoPlayer" */
            ).then(({default: videoPlayer}) => {
            new videoPlayer()
        })
    }

    if ($('[data-eco-block]').length > 0) {
        import(
            '@scripts/components/ecoBlocksConfig' /* webpackChunkName: "scripts/ecoBlocksConfig" */
            ).then(({default: ecoBlocksConfig}) => {
            new ecoBlocksConfig()
        })
    }
})
